import LiveVideo from './LiveVideo.vue'
export default LiveVideo



// WEBPACK FOOTER //
// ./src/views/monitoring/liveVideo/index.js